import { cloneDeep } from 'lodash';
import {
  SELECT_ALL_VALUE,
  ASCENDING,
  ASCENDING_SYMBOL,
  DESCENDING_SYMBOL,
} from '@/constants';

export function ConstructSearchPatternParam(
  paramIds: string | string[],
): string {
  let paramIdArray: string[] = [];
  if (Array.isArray(paramIds)) {
    paramIdArray = paramIds;
  } else {
    paramIdArray = [paramIds];
  }
  if (!paramIdArray || !paramIdArray.length) {
    return '';
  }
  const PARAM_ID_CLONE = cloneDeep(paramIdArray);
  const INDEX = PARAM_ID_CLONE.indexOf(SELECT_ALL_VALUE);
  if (INDEX !== -1) {
    PARAM_ID_CLONE.splice(INDEX, 1);
  }
  return `in:${PARAM_ID_CLONE.join(',')}`;
}

export default function constructAPIParams(params) {
  if (!params) {
    return {};
  }

  // There isn't a default sort defined, and it is likely id will be on everything, but we may want to revisit
  const SORT_DIRECTION =
    params.sortDirection === ASCENDING ? ASCENDING_SYMBOL : DESCENDING_SYMBOL;
  let sortBy: string = '+id';

  if (params.sortKey && params.sortKey.length) {
    sortBy = params.sortKey
      .split(',')
      .map((key) => {
        // apply direction only when not already set
        return key.startsWith(ASCENDING_SYMBOL) ||
          key.startsWith(DESCENDING_SYMBOL)
          ? key.trim()
          : `${SORT_DIRECTION}${key.trim()}`;
      })
      .join(',');
  }

  const PARAMS = {
    offset: params.rowsPerPage * (params.pageNumber - 1) || 0,
    limit: params.rowsPerPage || 10,
    sortBy,
    ...params.filters,
    ...(params.filters && params.filters.locationId
      ? { locationId: ConstructSearchPatternParam(params.filters.locationId) }
      : {}),
  };

  return PARAMS;
}
